"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroup = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var FormGroup = function (_a) {
    var _b;
    var className = _a.className, _c = _a.el, Element = _c === void 0 ? 'div' : _c, grouped = _a.grouped, inline = _a.inline, widths = _a.widths, props = __rest(_a, ["className", "el", "grouped", "inline", "widths"]);
    var FormGroupClasses = classnames_1.default('FormGroup', className, (_b = {
            'FormGroup--grouped': grouped,
            'FormGroup--inline': inline,
            'FormGroup--equal-width': widths === 'equal'
        },
        _b["FormGroup--widths-" + widths] = widths && widths !== 'equal',
        _b));
    return react_1.default.createElement(Element, __assign({}, props, { className: FormGroupClasses }));
};
exports.FormGroup = FormGroup;
exports.FormGroup.displayName = 'FormGroup';
//# sourceMappingURL=FormGroup.js.map